export default __webpack_public_path__ + "static/Button-en-f4150c22e170355307f63ae4f3e39e3b.png";